module.exports = __webpack_public_path__ + "static/img/Luke-Shuey.8fe9b7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Luke-Shuey.jpg
// module id = Pipu
// module chunks = 0